import { FindAllPaymentsResponseDTO, PaymentDTO, PaymentFilters } from "./dto";
import { PaymentServiceImpl } from "./serviceImpl";

export interface PaymentService {
    findAllPayments(filters: PaymentFilters): Promise<FindAllPaymentsResponseDTO>
    findPaymentById(id: string): Promise<PaymentDTO>
    createPayment(request: PaymentDTO): Promise<void>
    deletePayment(id: string): Promise<void>
    createPaymentWithId(id: string): Promise<void>
}

export function NewPaymentService(): PaymentService {
    return new PaymentServiceImpl();
}
